export default "__VITE_ASSET__T9odHRUa__"